// Mirrors CardNumberExtension.IsFormattingCharacter in CashOutValidationAPI, which rejects what this
// strips. Both sides name the same Unicode properties, so the sets cannot drift. Cf covers zero-width.
// The last character is U+2212 MINUS SIGN, which is Math_Symbol and so outside all three properties.
const FORMATTING_CHARACTERS = /[\p{White_Space}\p{Pd}\p{Cf}−]/gu;

export const normalizeCardNumber = (value: string): string =>
    value.replace(FORMATTING_CHARACTERS, '');
